import { Checkbox, Modal } from "antd";
import moment from "moment";
import React from "react";

const SystemMaintenanceClosed = (props) => {
  const july14 = 1752447600;
  const july16 = 1752645600;
  const betweenRange = moment().unix() > july14 && moment().unix() < july16;

  const onChange = (e) => {
    if (e.target.checked) {
      localStorage.setItem("maintenance-modal-16", "not-show");
    } else {
      localStorage.removeItem("maintenance-modal-16");
    }
  };

  return (
    <Modal
      open={
        props.open &&
        localStorage.getItem("maintenance-modal-16") !== "not-show" &&
        betweenRange
      }
      onCancel={props.onCancel}
      width={1000}
      footer={null}
    >
      <img src="/images/updateNotification.png" style={{ maxWidth: "100%" }} />
      <Checkbox onChange={onChange}>ไม่ต้องแสดงอีก</Checkbox>
    </Modal>
  );
};

export default SystemMaintenanceClosed;
